"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTriggerField = _interopRequireDefault(require("../cwtriggerfield/CwTriggerField"));

var _ValidationUtils = require("../../utils/ValidationUtils");

var CwPickerField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwPickerField, _React$Component);

  function CwPickerField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwPickerField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwPickerField).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputFocus", function () {
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputBlur", function () {
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (enteredText) {
      _this.setState({
        displayText: enteredText
      });

      if ((0, _ValidationUtils.IsEmpty)(enteredText)) {
        _this.props.onChange(null);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isValueIncomplete", function () {
      var valueText = _this.props.value ? _this.props.value[_this.props.nameField] : '';
      return valueText !== _this.state.displayText;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      if (event.key === 'Enter') {
        _this.handlePicker();
      } else if (event.key === 'Tab' && _this.isValueIncomplete() && !_this.props.disableTab) {
        _this.handlePicker();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePicker", function () {
      if (_this.props.disabled) {
        return;
      }

      if (_this.props.onPicker) {
        _this.props.onPicker(_this.isValueIncomplete() ? _this.state.displayText : '');
      }

      _this.focus();
    });
    _this.state = {
      displayText: ''
    };
    return _this;
  }

  (0, _createClass2.default)(CwPickerField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Display value's name if already given one when pickerfield re-mounts (i.e. after pod collapses then re-expands)
      if (this.props.value) {
        this.setState({
          displayText: this.props.value[this.props.nameField] ? this.props.value[this.props.nameField] : this.props.value
        });
      }

      if (this.props.onComponentDidMount) {
        this.props.onComponentDidMount();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nameField = nextProps.nameField ? nextProps.nameField : this.props.nameField; // Display value's name if receiving it from the parent

      if (nextProps.value && nextProps.value[nameField] !== undefined) {
        this.setState({
          displayText: nextProps.value[nameField]
        });
      } else {
        this.setState({
          displayText: ''
        });
      }

      if (this.props.onComponentWillReceiveProps) {
        this.props.onComponentWillReceiveProps(nextProps);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.cwTriggerField.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.field ? this.props.field : _react.default.createElement(_CwTriggerField.default, {
        cwId: this.props.cwId,
        triggerIcon: this.props.pickerIcon,
        autoComplete: "off",
        ref: function ref(input) {
          return _this2.cwTriggerField = input;
        },
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        value: this.state.displayText,
        disabled: this.props.disabled,
        invalid: this.props.invalid,
        readOnly: this.props.readOnly,
        onTrigger: this.handlePicker,
        className: this.props.className,
        customElement: this.props.customElement,
        autoFocus: this.props.autoFocus,
        placeholder: this.props.placeholder
      });
    }
  }]);
  return CwPickerField;
}(_react.default.Component);

CwPickerField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Path to picker icon
   */
  pickerIcon: _propTypes.default.string,

  /**
   * Callback function that is fired when picker field's text changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired on picker field focus
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired on picker field blur
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function that is fired when picker is clicked on
   */
  onPicker: _propTypes.default.func,

  /**
   * Used to control if picker field is valid
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable picker field
   */
  disabled: _propTypes.default.bool,

  /**
   * Text in textfield
   */
  value: _propTypes.default.any,

  /**
   * Used to add custom css
   */
  className: _propTypes.default.string,

  /**
   * Used to set input field to readonly
   */
  readOnly: _propTypes.default.bool,

  /**
   * Used to control if input field is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Used to add a custom element to the left side of the picker field
   */
  customElement: _propTypes.default.any,

  /**
   * The name of the field where text can be displayed. Will default to name
   */
  nameField: _propTypes.default.string,

  /**
   * Alternative component to use for the text field
   */
  field: _propTypes.default.object,

  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes.default.string,

  /**
   * Boolean to disable opening a picker when user hits tab key
   */
  disableTab: _propTypes.default.bool
};
CwPickerField.defaultProps = {
  nameField: 'name',
  disableTab: false
};
var _default = CwPickerField;
exports.default = _default;